
define('text!modules/campaign/bulkedit/targeting/location/templates/grid_footer.html',[],function () { return '<div class="w-foot-c">\n    <div class="browse-path-selected">\n        <div class="stack browse-path" data-bind="browse_path">{{{browse_path}}}<span class="strong">{{{browse_path_end}}}&nbsp;</span></div>\n    </div>\n</div>';});

